import { Icon } from '@beacon/ui/components';

export function PromptsEmptyState() {
  return (
    <div className="text-text-3 flex h-full flex-col items-center justify-center gap-3 p-8 text-center">
      <Icon symbol="file-text-line" className="text-text-3 size-8" />
      <p className="text-sm">Select a prompt version to view or edit.</p>
    </div>
  );
}
